<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>

  <ng-container *ngIf="!isViewAll">
    <app-position-out-config 
      [elementChoosing]="objectChoosing" 
      [device]="device"
      [id_parent_choose]="objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
    </app-position-out-config>
    <app-width-height-config 
      [elementChoosing]="objectChoosing"
      [device]="device" 
      [width]="class['text']['width']"  
      [height]="class['text']['height']"
      (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>

    <ul nz-menu nzMode="inline">
      <!-- Kiểu hiển thị -->
      <li nz-submenu nzTitle="{{'kieu_hien_thi' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <nz-select [(ngModel)]="config['view-type']['overflow-y']" (ngModelChange)="updateTypeDisplay()">
          <nz-option nzValue="visible" nzLabel="{{'dan' | translate}}"></nz-option>
          <nz-option nzValue="auto" nzLabel="{{'cuon' | translate}}"></nz-option>
          <nz-option nzValue="hidden" nzLabel="{{'co_dinh' | translate}}"></nz-option>
          <nz-option *ngIf="['AtwTextShortDescription', 'AtwDescriptionNews', 'AtwDetailedDescription'].includes(objectChoosing?.component)" nzValue="read-more" [nzLabel]="'xem_them' | translate"></nz-option>
        </nz-select>

        <!-- Cấu hình thanh cuộn -->
        <ng-container *ngIf="class?.['text']?.['overflow-y'] == 'auto' && config?.['view-type']?.['overflow-y'] == 'auto'">
          <!-- Độ rộng thanh cuộn -->
          <div>
            <div class="config-name">
              <p>{{'do_rong_thanh_cuon' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100"
                [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div> 
            <div>
              <nz-slider [nzMin]="1" [nzMax]="100" 
                [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'"
                (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
          </div>
          <!-- Bo góc thanh cuộn -->
          <div>
            <div class="config-name">
              <p>{{'bo_goc_thanh_cuon' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100"
                [ngModel]="config['-webkit-scrollbar']['border-radius'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['border-radius'] = $event +'px'"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div> 
            <div>
              <nz-slider [nzMin]="1" [nzMax]="100" 
                [ngModel]="config['-webkit-scrollbar']['border-radius'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['border-radius'] = $event +'px'"
                (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
          </div>
          <!-- Màu nền thanh cuộn -->
          <div class="config-name mt-4">
            <p>{{'mau_nen_thanh_cuon' | translate}}</p>
            <div>
              <input class="input-color" type="button"
                [cpOKButton]="true" 
                [style.background]="config['-webkit-scrollbar']['background-color']"
                [(colorPicker)]="config['-webkit-scrollbar']['background-color']"
                (colorPickerClose)="updateConfig()" />
            </div>
          </div>
          <!-- Màu thanh cuộn -->
          <div class="config-name mt-4">
            <p>{{'mau_thanh_keo' | translate}}</p>
            <div>
              <input class="input-color" type="button"
                [cpOKButton]="true" 
                [style.background]="config['-webkit-scrollbar']['thumb-background-color']"
                [(colorPicker)]="config['-webkit-scrollbar']['thumb-background-color']"
                (colorPickerClose)="updateConfig()" />
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="config?.['view-type']?.['overflow-y'] == 'read-more' && ['AtwTextShortDescription', 'AtwDescriptionNews', 'AtwDetailedDescription'].includes(objectChoosing?.component)">
          <!-- Hiển thị văn bản -->
          <div class="config-name">
            <span>{{'hien_thi_van_ban' | translate}}</span>  
            <nz-switch [(ngModel)]="config['view-type']['isOpen']" (ngModelChange)="updateTypeDisplay()">
            </nz-switch>
          </div>

          <!-- Phần mờ -->
          <li nz-submenu [nzTitle]="'phan_mo' | translate">
            <!-- Chiều cao phần mờ -->
            <div class="config-name">
              <p>{{'chieu_cao' | translate}}</p>  
              <nz-input-number [nzMin]="1" [nzMax]="300"
                [ngModel]="class['read-more__blur']['height'] | vhnumber"
                (ngModelChange)="class['read-more__blur']['height'] = $event +'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div> 
            <div>
              <nz-slider [nzMin]="1" [nzMax]="100" 
                [ngModel]="class['read-more__blur']['height'] | vhnumber"
                (ngModelChange)="class['read-more__blur']['height'] = $event +'px'"
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
            <!-- Màu phần mờ -->
            <div class="config-name mt-4">
              <p>{{'mau' | translate}}</p>
              <div>
                <input class="input-color" type="button"
                  [cpOKButton]="true" 
                  [style.background]="config['view-type']['blur_background_color']"
                  [(colorPicker)]="config['view-type']['blur_background_color']"
                  (colorPickerClose)="updateConfig()" />
              </div>
            </div>
          </li>
        </ng-container>
      </li>

      <ng-container *ngIf="config['view-type']['overflow-y'] == 'read-more' && ['AtwTextShortDescription', 'AtwDescriptionNews', 'AtwDetailedDescription'].includes(objectChoosing?.component)">
        <!-- Phần nút xem thêm -->
        <li nz-submenu nzTitle="{{'phan_nut_xem_them' | translate}}" [(nzOpen)]="openMap.menu4"
          (nzOpenChange)="openHandler('menu4')">
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label> {{'noi_dung_xem_them' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata['+content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                (ngModelChange)="staticdata['+content_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('+content');"></textarea>
            </mat-form-field>
          </div>
          <ng-container>
            <!-- Định dạng tên nút -->
            <li nz-submenu [nzTitle]="'dinh_dang_ten_nut' | translate">
              <div class="container-font">
                <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
                  [staticdata]="staticdata" [textContentClass]="class['+read-more__button-content']" [textWrapperClass]="class['+read-more__button']">
                </app-text-format-config>
                <!-- Khoảng cách chữ -->
                <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                  [classLetterSpacing]="class['+read-more__button-content']" (updateClass)="updateClass()">
                </app-letter-spacing-config>
                <!-- Khoảng cách dòng -->
                <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                  [classLineHeight]="class['+read-more__button-content']" (updateClass)="updateClass()">
                </app-line-height-config>
              </div>
            </li>

            <!-- Điều chỉnh nút -->
            <li nz-submenu [nzTitle]="'dieu_chinh_nut' | translate">
              <!-- Chiều dài -->
              <div class="config-name">
                <p class="mb-0" style="width: 50%;">{{'chieu_dai' | translate}} (%)</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="0.1" [ngModel]="class['+read-more__button']['width'] | vhnumber"
                  (nzBlur)="updateClass()" (ngModelChange)="class['+read-more__button']['width'] = $event + '%'">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1" [ngModel]="class['+read-more__button']['width'] | vhnumber"
                    (ngModelChange)="class['+read-more__button']['width'] = $event + '%'" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </nz-col>
              </nz-row>
              <!-- Chiều cao -->
              <div class="config-name mt-2">
                <p class="mb-0" style="width: 50%;">{{'chieu_cao' | translate}} (px)</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="0.1" [ngModel]="class['+read-more__button']['height'] | vhnumber"
                  (nzBlur)="updateClass()" (ngModelChange)="class['+read-more__button']['height'] = $event + 'px'">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1" [ngModel]="class['+read-more__button']['height'] | vhnumber"
                    (ngModelChange)="class['+read-more__button']['height'] = $event + 'px'" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </nz-col>
              </nz-row>
              <!-- Màu nền -->
              <div class="config-name">
                <label class="px-1">{{'mau_nen' | translate}}</label>
                <input class="input-color mt-1" type="button"
                  [cpOKButton]="true" 
                  [style.background]="class['+read-more__button']['background-color']"
                  [(colorPicker)]="class['+read-more__button']['background-color']"
                  (colorPickerClose)="updateClass()" />
              </div>
              <!-- Canh lề bên trên nút -->
              <div class="config-name">
                <p class="mb-0" style="width: 50%;">{{'canh_le_ben_tren' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="0.1" [ngModel]="class['+read-more__button']['margin-top'] | vhnumber"
                  (ngModelChange)="class['+read-more__button']['margin-top'] = $event + 'px'" (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1" [ngModel]="class['+read-more__button']['margin-top'] | vhnumber"
                    (ngModelChange)="class['+read-more__button']['margin-top'] = $event + 'px'" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </nz-col>
              </nz-row>
              <!-- Canh lề bên dưới nút -->
              <div class="config-name">
                <p class="mb-0" style="width: 50%;">{{'canh_le_ben_duoi' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="0.1" [ngModel]="class['+read-more__button']['margin-bottom'] | vhnumber"
                  (ngModelChange)="class['+read-more__button']['margin-bottom'] = $event + 'px'" (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1" [ngModel]="class['+read-more__button']['margin-bottom'] | vhnumber"
                    (ngModelChange)="class['+read-more__button']['margin-bottom'] = $event + 'px'" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </nz-col>
              </nz-row>
            </li>

            <!-- Đổ bóng -->
            <li nz-submenu [nzTitle]="'do_bong' | translate">
              <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['+read-more__button']"
                [shadowConfig]="config['view-type']['+button_box_shadow']" [objectChoosing]="objectChoosing">
              </app-shadow-config>
            </li>

            <!-- Viền -->
            <li nz-submenu [nzTitle]="'kieu_vien' | translate">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderClass]="class['+read-more__button']" [id_object]="objectChoosing._id">
              </app-borders-config>

              <!-- Nút mở rộng -->
              <div class="item-border my-3" style="float: right">
                <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
                  {{'mo_rong' | translate}} &#8594;
                </p>
              </div>
            </li>

            <!-- Cấu hình biểu tượng -->
            <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}">
              <app-symbol-config [device]="device" [class]="class" [config]="config" [symbolClass]="class['+read-more__button']"
                [fontSizeIconClass]="class['+read-more__icon-wrapper']" [symbolConfig]="config['view-type']['+flex-direction']"
                [objectChoosing]="objectChoosing">
              </app-symbol-config>

              <div>
                <li nz-submenu nzTitle="{{'khoang_dem' | translate}}">
                  <!-- Khoảng đệm của khung chứa biểu tượng -->
                  <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                    [classPadding]="class['+read-more__icon-wrapper']" [paddingConfigs]="[
                      { type: 'top' },
                      { type: 'bottom' },
                      { type: 'left' },
                      { type: 'right' }
                    ]">
                  </app-padding-config>
                </li>
              </div>
              <!-- Nút mở rộng -->
              <div class="item-border my-3" style="float: right">
                <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[2])">
                  {{'mo_rong' | translate}} &#8594;
                </p>
              </div>
            </li>
          </ng-container>  
        </li>

        <!-- Phần nút thu gọn -->
        <li nz-submenu nzTitle="{{'phan_nut_thu_gon' | translate}}" [(nzOpen)]="openMap.menu5"
          (nzOpenChange)="openHandler('menu5')">
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label> {{'noi_dung_rut_gon' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata['-content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                (ngModelChange)="staticdata['-content_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('-content');"></textarea>
            </mat-form-field>
          </div>
          <ng-container>
            <!-- Định dạng tên nút -->
            <li nz-submenu [nzTitle]="'dinh_dang_ten_nut' | translate">
              <div class="container-font">
                <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
                  [staticdata]="staticdata" [textContentClass]="class['-read-more__button-content']" [textWrapperClass]="class['-read-more__button']">
                </app-text-format-config>
                <!-- Khoảng cách chữ -->
                <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                  [classLetterSpacing]="class['-read-more__button-content']" (updateClass)="updateClass()">
                </app-letter-spacing-config>
                <!-- Khoảng cách dòng -->
                <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                  [classLineHeight]="class['-read-more__button-content']" (updateClass)="updateClass()">
                </app-line-height-config>
              </div>
            </li>

            <!-- Điều chỉnh nút -->
            <li nz-submenu [nzTitle]="'dieu_chinh_nut' | translate">
              <!-- Chiều dài -->
              <div class="config-name">
                <p class="mb-0" style="width: 50%;">{{'chieu_dai' | translate}} (%)</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="0.1" [ngModel]="class['-read-more__button']['width'] | vhnumber"
                  (nzBlur)="updateClass()" (ngModelChange)="class['-read-more__button']['width'] = $event + '%'">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1" [ngModel]="class['-read-more__button']['width'] | vhnumber"
                    (ngModelChange)="class['-read-more__button']['width'] = $event + '%'" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </nz-col>
              </nz-row>
              <!-- Chiều cao -->
              <div class="config-name mt-2">
                <p class="mb-0" style="width: 50%;">{{'chieu_cao' | translate}} (px)</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="0.1" [ngModel]="class['-read-more__button']['height'] | vhnumber"
                  (nzBlur)="updateClass()" (ngModelChange)="class['-read-more__button']['height'] = $event + 'px'">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1" [ngModel]="class['-read-more__button']['height'] | vhnumber"
                    (ngModelChange)="class['-read-more__button']['height'] = $event + 'px'" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </nz-col>
              </nz-row>
              <!-- Màu nền -->
              <div class="config-name">
                <label class="px-1">{{'mau_nen' | translate}}</label>
                <input class="input-color mt-1" type="button"
                  [cpOKButton]="true" 
                  [style.background]="class['-read-more__button']['background-color']"
                  [(colorPicker)]="class['-read-more__button']['background-color']"
                  (colorPickerClose)="updateClass()" />
              </div>
              <!-- Canh lề bên trên nút -->
              <div class="config-name">
                <p class="mb-0" style="width: 50%;">{{'canh_le_ben_tren' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="0.1" [ngModel]="class['-read-more__button']['margin-top'] | vhnumber"
                  (ngModelChange)="class['-read-more__button']['margin-top'] = $event + 'px'" (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1" [ngModel]="class['-read-more__button']['margin-top'] | vhnumber"
                    (ngModelChange)="class['-read-more__button']['margin-top'] = $event + 'px'" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </nz-col>
              </nz-row>
              <!-- Canh lề bên dưới nút -->
              <div class="config-name">
                <p class="mb-0" style="width: 50%;">{{'canh_le_ben_duoi' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="0.1" [ngModel]="class['-read-more__button']['margin-bottom'] | vhnumber"
                  (ngModelChange)="class['-read-more__button']['margin-bottom'] = $event + 'px'" (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1" [ngModel]="class['-read-more__button']['margin-bottom'] | vhnumber"
                    (ngModelChange)="class['-read-more__button']['margin-bottom'] = $event + 'px'" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </nz-col>
              </nz-row>
            </li>

            <!-- Đổ bóng -->
            <li nz-submenu [nzTitle]="'do_bong' | translate">
              <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['-read-more__button']"
                [shadowConfig]="config['view-type']['-button_box_shadow']" [objectChoosing]="objectChoosing">
              </app-shadow-config>
            </li>

            <!-- Viền -->
            <li nz-submenu [nzTitle]="'kieu_vien' | translate">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderClass]="class['-read-more__button']" [id_object]="objectChoosing._id">
              </app-borders-config>

              <!-- Nút mở rộng -->
              <div class="item-border my-3" style="float: right">
                <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[3])">
                  {{'mo_rong' | translate}} &#8594;
                </p>
              </div>
            </li>

            <!-- Cấu hình biểu tượng -->
            <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}">
              <app-symbol-config [device]="device" [class]="class" [config]="config" [symbolClass]="class['-read-more__button']"
                [fontSizeIconClass]="class['-read-more__icon-wrapper']" [symbolConfig]="config['view-type']['-flex-direction']"
                [objectChoosing]="objectChoosing">
              </app-symbol-config>

              <div>
                <li nz-submenu nzTitle="{{'khoang_dem' | translate}}">
                  <!-- Khoảng đệm của khung chứa biểu tượng -->
                  <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                    [classPadding]="class['-read-more__icon-wrapper']" [paddingConfigs]="[
                      { type: 'top' },
                      { type: 'bottom' },
                      { type: 'left' },
                      { type: 'right' }
                    ]">
                  </app-padding-config>
                </li>
              </div>
              <!-- Nút mở rộng -->
              <div class="item-border my-3" style="float: right">
                <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[4])">
                  {{'mo_rong' | translate}} &#8594;
                </p>
              </div>
            </li>
          </ng-container>
        </li>
      </ng-container>
      <!-- Điều chỉnh -->
      <li nz-submenu nzTitle="{{'dieu_chinh' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <!-- Kích thước -->
        <div class="config-name">
          <p class="mb-0">{{'kich_thuoc' | translate}}:</p>
          <mat-form-field title="Size" style="width: 50%">
            <mat-label> {{'kich_thuoc' | translate}}</mat-label>
            <input (blur)="updateClass()" matInput type="number" [ngModel]="class['text__editor']['font-size'] | vhnumber"
              (ngModelChange)="class['text__editor']['font-size'] =$event + 'px'" />
          </mat-form-field>
        </div>
          <!-- Mở màu chữ -->
        <div class="config-name">
          <p class="mb-0">{{'mo_mau_chu' | translate}}</p>
          <nz-switch [ngModel]="class['text__editor']?.['color'] && class['text__editor']?.['color'] !== 'unset'"
          (ngModelChange)="class['text__editor']['color'] = $event ? '#000000' : 'unset';updateClass()">
          </nz-switch>
        </div>
        <!-- Màu chữ -->
        <div class="config-name" *ngIf="class['text__editor']?.['color'] && class['text__editor']?.['color'] !== 'unset'">
          <p class="mb-0">{{'mau_chu' | translate}}</p>
          <input type="button" class="input-color w-50" [cpOKButton]="true" [(colorPicker)]="class['text__editor']['color']" 
          [style.background]="class['text__editor']['color']" (colorPickerClose)="updateClass()" [cpWidth]="'230px'" />
        </div>
        <!-- Khoảng cách dòng -->
        <div class="config-name">
          <p class="mb-0" style="width: 50%;">{{'khoang_cach_dong' | translate}}</p>
          <nz-input-number [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1" [(ngModel)]="class['text__editor']['line-height']"
            (nzBlur)="updateClass()">
          </nz-input-number>
        </div>
        <nz-row>
          <nz-col nzSpan="24">
            <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1" [(ngModel)]="class['text__editor']['line-height']"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </nz-col>
        </nz-row>
        <!-- Khoảng cách các đoạn văn bản trong nội dung -->
        <div class="config-name">
          <p class="mb-0" style="width: 60%;">{{'khoang_cach_cac_doan_van_ban_trong_noi_dung' | translate}}</p>
          <nz-input-number [nzMin]="0" [nzMax]="300" [nzStep]="1"
            [ngModel]="config.padding_bottom?.p | vhnumber"
            (ngModelChange)="config.padding_bottom.p = $event + 'px'"
            (nzBlur)="updateConfig()">
          </nz-input-number>
        </div>
        <nz-row>
          <nz-col nzSpan="24">
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="10"
              [ngModel]="config.padding_bottom?.p | vhnumber"
              (ngModelChange)="config.padding_bottom.p = $event + 'px'"
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </nz-col>
        </nz-row>
      </li>

      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')"
      *ngIf="config['view-type']?.['overflow-y'] != 'read-more'">
        <app-choose-animations-config [elementChoosing]="objectChoosing" [id_object]="objectChoosing._id"
          [device]="device" [class]="class" [config]="config" [staticdata]="staticdata" [cursorClass]="class[getClassNameCursor]"
          [effect_hover]="effect_hover" [customize]="customize" (openAnimationDetail)="openAnimationDetail($event)"
          [effectFileUsing]="'short-description'">
        </app-choose-animations-config>
      </li>
      <!-- Lựa chọn hiển thị cho các thiết bị -->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu3"
      (nzOpenChange)="openHandler('menu3')">
        <div class="editor-field">
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="config['animation-selected'].id != '000000' && currentViewAll.index == 1">
      <app-animations-config [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata"
        [id_object]="objectChoosing._id" [customize]="customize"></app-animations-config>
    </div>

    <!-- Cấu hình chi tiết viền của xem thêm -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['+read-more__button']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết viền của xem thêm -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <!-- Viền của biểu tượng -->
      <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderClass]="class['+read-more__icon-wrapper']" [id_object]="objectChoosing._id">
      </app-borders-config>

      <!-- Bo tròn viền biểu tượng -->
      <p class="title-head mt-4">{{'bo_tron_nen' | translate}}</p>
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['+read-more__icon-wrapper']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết viền của thu gọn -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 4">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['-read-more__button']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết viền của thu gọn -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 5">
      <!-- Viền của biểu tượng -->
      <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderClass]="class['-read-more__icon-wrapper']" [id_object]="objectChoosing._id">
      </app-borders-config>

      <!-- Bo tròn viền biểu tượng -->
      <p class="title-head mt-4">{{'bo_tron_nen' | translate}}</p>
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['-read-more__icon-wrapper']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>